// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav.primary-nav-wrapper {
  background-color: var(--clr-black);
  color: var(--clr-white);
  border: var(--border-nav);
  border-width: 3px 0;
  position: relative;
} 

div.primary-nav-outer-wrapper {
  padding-top: 1em;
}

div.primary-nav-inner-wrapper {
  max-width: min(1400px, calc(100vw - 40px));

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  padding: 0em 1em 0em 0.5em;

  margin: auto;
}

nav.primary-nav-wrapper ul {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.8em;
  height: 100%;
  position: relative;
}

nav.primary-nav-wrapper a {
  color: var(--clr-white);
  user-select: none;
}

nav.primary-nav-wrapper a:active:hover span.nav-link-label {
  scale: 0.9;
}

div.nav-link-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
}

span.nav-link-label {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.5em;
  font-weight: 700;
  height: 3em;
  padding: 0.5em;
  z-index: 3;
}

div.nav-link-wrapper::before, div.nav-link-wrapper::after {
  content: '';
  height: 0.5em;
  width: 100%;
  position:absolute;
  z-index: 2;
  border: var(--border-nav);
  border-color: transparent;
}

div.nav-link-wrapper::before {
  border-radius: 5px 5px 0 0;
  border-width: 3px 0 0 0;
  top: -5px;
}

div.nav-link-wrapper::after {
  border-radius: 5px 5px 0 0;
  border-width: 3px 0 0 0;
  bottom: -5px;
}

nav.primary-nav-wrapper a.active>div.nav-link-wrapper::before {
  background-color: var(--clr-black);
  border-color: var(--clr-accent-light);
}

nav.primary-nav-wrapper a.active>div.nav-link-wrapper::after {
  background: var(--bg-gradient);
  background-attachment: fixed;
  border-color: var(--clr-accent-light);
}

nav.primary-nav-wrapper a.active span.nav-link-label {
  translate: 0 -4px;
}

nav.primary-nav-wrapper a:hover, nav.primary-nav-wrapper a:focus {
  color: var(--clr-accent-light);
}

@media (max-width: 980px) {
  span.nav-hide-when-small {
    display: none;
  }

  nav.primary-nav-wrapper ul {
    justify-content: center;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/nav/primaryNav/PrimaryNav.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;;EAE1C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;;EAE1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;AACF","sourcesContent":["nav.primary-nav-wrapper {\n  background-color: var(--clr-black);\n  color: var(--clr-white);\n  border: var(--border-nav);\n  border-width: 3px 0;\n  position: relative;\n} \n\ndiv.primary-nav-outer-wrapper {\n  padding-top: 1em;\n}\n\ndiv.primary-nav-inner-wrapper {\n  max-width: min(1400px, calc(100vw - 40px));\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: start;\n  padding: 0em 1em 0em 0.5em;\n\n  margin: auto;\n}\n\nnav.primary-nav-wrapper ul {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 0.8em;\n  height: 100%;\n  position: relative;\n}\n\nnav.primary-nav-wrapper a {\n  color: var(--clr-white);\n  user-select: none;\n}\n\nnav.primary-nav-wrapper a:active:hover span.nav-link-label {\n  scale: 0.9;\n}\n\ndiv.nav-link-wrapper {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\nspan.nav-link-label {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5em;\n  font-weight: 700;\n  height: 3em;\n  padding: 0.5em;\n  z-index: 3;\n}\n\ndiv.nav-link-wrapper::before, div.nav-link-wrapper::after {\n  content: '';\n  height: 0.5em;\n  width: 100%;\n  position:absolute;\n  z-index: 2;\n  border: var(--border-nav);\n  border-color: transparent;\n}\n\ndiv.nav-link-wrapper::before {\n  border-radius: 5px 5px 0 0;\n  border-width: 3px 0 0 0;\n  top: -5px;\n}\n\ndiv.nav-link-wrapper::after {\n  border-radius: 5px 5px 0 0;\n  border-width: 3px 0 0 0;\n  bottom: -5px;\n}\n\nnav.primary-nav-wrapper a.active>div.nav-link-wrapper::before {\n  background-color: var(--clr-black);\n  border-color: var(--clr-accent-light);\n}\n\nnav.primary-nav-wrapper a.active>div.nav-link-wrapper::after {\n  background: var(--bg-gradient);\n  background-attachment: fixed;\n  border-color: var(--clr-accent-light);\n}\n\nnav.primary-nav-wrapper a.active span.nav-link-label {\n  translate: 0 -4px;\n}\n\nnav.primary-nav-wrapper a:hover, nav.primary-nav-wrapper a:focus {\n  color: var(--clr-accent-light);\n}\n\n@media (max-width: 980px) {\n  span.nav-hide-when-small {\n    display: none;\n  }\n\n  nav.primary-nav-wrapper ul {\n    justify-content: center;\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
